import type { TextNode } from 'lexical'
import {
    $createTextNode,
    $getSelection,
    $isElementNode,
    $isRangeSelection,
    $isTextNode,
} from 'lexical'

// Inserts text right after selection, selection must be a range selection as well as containing text nodes only
const insertTextAfterSelection = (textToInsert: string): TextNode | null => {
    const selection = $getSelection()
    if (!$isRangeSelection(selection)) {
        return null
    }

    let { anchor, focus } = selection
    if (selection.isBackward()) {
        ;[anchor, focus] = [focus, anchor]
    }
    const focusNode = focus.getNode()
    if ($isElementNode(focusNode)) {
        const textNode = $createTextNode(textToInsert)
        focusNode.append(textNode)
        return textNode
    }

    if (!$isTextNode(focusNode) || !focusNode.isSimpleText()) {
        return null
    }

    // the number of characters between the start of the text node and the focus
    const { offset } = focus
    const [nodeToAppendTo] = focusNode.splitText(offset)

    if (offset > 0) {
        const textNode = $createTextNode(` ${textToInsert}`)
        nodeToAppendTo.insertAfter(textNode)
        return textNode
    }

    const textNode = $createTextNode(textToInsert)
    nodeToAppendTo.insertBefore(textNode)
    return textNode
}

export { insertTextAfterSelection }
